var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-badge',{attrs:{"inline":"","left":"","color":_vm.color,"dot":""}},[_vm._v("\n          "+_vm._s(_vm.representation)+"\n        ")])
}
var staticRenderFns = []

export { render, staticRenderFns }